<header class="c-header">
	<div class="c-header__top-bar" [class.c-header__top-bar--no-hide]="languages.length > 1">
		<a class="c-header__top-bar__link c-header__top-bar__link--lg" rel="noopener noreferrer" href="http://www.vlaanderen.be/nl" target="_blank">Vlaanderen</a>

		<ng-container *ngIf="!unbrand">
			<div class="c-header__top-bar__divider"></div>
			<a class="c-header__top-bar__link c-header__top-bar__link--sm" rel="noopener noreferrer" href="http://www.toerismevlaanderen.be" target="_blank">Toerisme Vlaanderen</a>
		</ng-container>

		<div class="c-header__top-bar__filler"></div>

		<div *ngIf="languages.length > 1">
			<button *ngFor="let lang of languages" class="c-btn-language" [class.c-btn-language--active]="activeLanguage === lang" (click)="setLang(lang)">{{ lang }}</button>
		</div>
	</div>

	<div *ngIf="logo || brand" class="c-header__bar">
		<div class="u-container">
			<div class="c-header__brand">
				<div *ngIf="disableHome" class="c-header__brand__logo">
					<img [src]="logo" [alt]="logoAlt" />
				</div>
				<a *ngIf="!disableHome" class="c-header__brand__logo" [routerLink]="customHome || ['/']" [queryParams]="customQuery || {}">
					<img [src]="logo" [alt]="logoAlt" />
				</a>

				<p class="c-header__brand__title">{{ brand }}</p>
			</div>

			<div *ngIf="user" class="c-header__user-menu">
				<div class="c-header__user-menu__button">
					<div class="flex-row">
						<div class="c-header__user-menu__icon">
							<tvcore-icon name="profile"></tvcore-icon>
						</div>

						<span>{{ user.contact.person?.firstName }} {{ user.contact.person?.lastName }}</span>
					</div>
				</div>

				<div class="c-header__user-menu__flyout">
					<div class="flex-row u-m-bottom--sm">
						<div class="c-header__user-menu__icon">
							<tvcore-icon name="profile"></tvcore-icon>
						</div>

						<span>{{ user.contact.person?.firstName }} {{ user.contact.person?.lastName }}</span>
					</div>

					<button class="c-btn-link" (click)="doLogout()">Uitloggen</button>
				</div>
			</div>
		</div>
	</div>

	<div
		*ngIf="toast$ | async as toast"
		class="c-toast"
		[class.c-toast--green]="toast.type === ToastType.SUCCESS"
		[class.c-toast--red]="toast.type === ToastType.ERROR"
		[class.c-toast--show]="toast.show"
	>
		<div class="c-toast__content">
			<div class="flex-column flex--1">
				<p>{{ toast.message }}</p>
				<p *ngIf="toast.info" class="u-text--xs">{{ toast.info }}</p>
			</div>

			<tvcore-icon name="close" (click)="closeToast()"></tvcore-icon>
		</div>
	</div>
</header>
